// src/pages/Reports/IssuanceReporting/PeriodSummaryClosing/ClosePeriodModal.tsx
// RPT-018 (README.md mục 7) — modal chốt kỳ. Mặc định yêu cầu TẤT CẢ đại lý có giao vé trong kỳ
// phải đã Xác nhận đối soát — nếu còn thiếu, BE trả lỗi 409 trừ khi "Chốt cưỡng chế" (kèm lý do
// bắt buộc). Xem ClosePeriodCommand bên ticket-service.

import React, { useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';

import { closePeriodApi } from 'helpers/fakebackend_helper';
import { PeriodClosing } from '../shared/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface ClosePeriodModalProps {
  isOpen: boolean;
  planId: number;
  closing: PeriodClosing | null;
  onClose: () => void;
  onClosed: () => void;
}

const ClosePeriodModal: React.FC<ClosePeriodModalProps> = ({ isOpen, planId, closing, onClose, onClosed }) => {
  const [forceClose, setForceClose] = useState(false);
  const [forceCloseReason, setForceCloseReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleToggle = () => {
    if (submitting) return;
    setForceClose(false);
    setForceCloseReason('');
    onClose();
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (forceClose && !forceCloseReason.trim()) {
      toast.error(st('vui_long_nhap_ly_do_chot_message'));
      return;
    }
    setSubmitting(true);
    try {
      await closePeriodApi({
        issuancePlanId: planId,
        forceClose,
        forceCloseReason: forceClose ? forceCloseReason.trim() : undefined,
      });
      toast.success(st('chot_ky_thanh_cong_message'));
      setForceClose(false);
      setForceCloseReason('');
      onClosed();
    } catch (error: any) {
      toast.error(error?.message || st('khong_the_chot_ky_message'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} centered>
      <ModalHeader className="bg-light p-3" toggle={handleToggle}>{st('chot_ky_phat_hanh_title')}</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {closing && closing.agentsNotReconciledCount > 0 && (
            <div className="alert alert-warning">
              {st('con_text')} <strong>{closing.agentsNotReconciledCount}</strong> {st('dai_ly_chua_doi_soat_cho_text')}
            </div>
          )}
          {closing && (
            <div className="mb-3 text-muted">
              {st('da_doi_soat_text')} {closing.agentsReconciledCount} {st('chua_doi_soat_text')} {closing.agentsNotReconciledCount} {st('co_chenh_lech_text')} {closing.agentsWithDiscrepancyCount}
            </div>
          )}
          <FormGroup check className="mb-3">
            <Input
              type="checkbox"
              id="forceClose"
              checked={forceClose}
              onChange={(e) => setForceClose(e.target.checked)}
            />
            <Label check htmlFor="forceClose">{st('chot_cuong_che_bo_qua_dieu_label')}</Label>
          </FormGroup>
          {forceClose && (
            <FormGroup>
              <Label>{st('ly_do_chot_cuong_che_label')} <span className="text-danger">*</span></Label>
              <Input
                required
                type="textarea"
                rows={3}
                value={forceCloseReason}
                onChange={(e) => setForceCloseReason(e.target.value)}
                placeholder={st('neu_ro_ly_do_chot_ky_placeholder')}
              />
            </FormGroup>
          )}
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <Button color="light" onClick={handleToggle} disabled={submitting}>{st('huy_column')}</Button>
            <Button color="danger" type="submit" disabled={submitting}>
              {submitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
              {st('xac_nhan_chot_ky_button')}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default ClosePeriodModal;
